import { render, staticRenderFns } from "./ContentBlocker.html?vue&type=template&id=3154098a&scoped=true&"
import script from "./ContentBlocker.js?vue&type=script&lang=js&"
export * from "./ContentBlocker.js?vue&type=script&lang=js&"
import style0 from "./ContentBlocker.scss?vue&type=style&index=0&id=3154098a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3154098a",
  null
  
)

export default component.exports